import { render, staticRenderFns } from "./CodeViewer.vue?vue&type=template&id=efffc242&scoped=true"
import script from "./CodeViewer.vue?vue&type=script&lang=js"
export * from "./CodeViewer.vue?vue&type=script&lang=js"
import style0 from "./CodeViewer.vue?vue&type=style&index=0&id=efffc242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efffc242",
  null
  
)

export default component.exports